import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "43",
  viewBox: "0 0 51.498 51.498"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Group 4217" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8008",
    d: "M24 2a22 22 0 1 0 15.556 6.444A22 22 0 0 0 24 2zm0 40.857a18.857 18.857 0 1 1 13.334-5.523A18.857 18.857 0 0 1 24 42.857z",
    transform: "translate(-2 -2)",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8009",
    d: "M18.217 7H15v15.54l12.242 5.244 1.255-2.96-10.28-4.408z",
    transform: "translate(5.221 .698)",
    style: {"fill":"#fff"}
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };